export const isBase64PDF = (data: string) => {
  return data.startsWith('JVBER');
};

export const OpenPDF = ({
  filename,
  data,
  download,
}: {
  filename: string;
  data: string;
  download?: boolean;
}) => {
  const anchor = document.createElement('a');
  if (download) {
    anchor.download = filename;
  } else {
    anchor.target = '_blank';
  }
  anchor.href = `data:application/pdf;base64,${data}`;

  anchor.click();
};
